module.exports = __webpack_public_path__ + "static/media/fallback.ca6bddcd.png";